import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Ключ Stripe для вкладки Shop → Stripe. Живёт ТОЛЬКО в памяти вкладки: не в localStorage,
 * не в sessionStorage, не на сервере — сервер читает его из заголовка запроса и не сохраняет.
 * Перезагрузка страницы или выход из панели его забывают.
 */
export const useStripeKeyStore = defineStore('stripeKey', () => {
  const key = ref('');
  function set(value: string) {
    key.value = value.trim();
  }
  function forget() {
    key.value = '';
  }
  return { key, set, forget };
});
